const recipientName = (state = "", action) => {
    switch(action.type) {
        case 'recipientName':
            return action.payload;
        default:
            return state;
    }
}

export default recipientName;